<template>
<div style="background-color: #fff;margin:24px">
	<div v-if="isHome">
		<top-title
				name="品牌会员中心"
				pageName="品牌定制-品牌会员中心"
				style=" min-width: 1066px"
		></top-title>
		<div class="integralEden">
				<div class="content">
					<div class="card-point tipBg">
						<div class="card-connet">
								<p>会员中心ISV定制版，提高会员归属感，助力品牌攀登会员运营新高度！</p>
						</div>

					</div>
					<el-tabs v-model="tabActive" type="card" @tab-click="handleClick">
						<el-tab-pane label="模块管理" name="1"></el-tab-pane>
					</el-tabs>

					<!-- 模块管理 -->
					<div v-if="tabActive == 1">
						<div class="card-connet" style="margin-bottom: 30px;"> 
							注：此处为定制模块的设置页面，如需将设置好的模块装修到会员中心，请前往
							<span style="color: #409EFF;cursor: pointer;text-decoration: underline" @click="toPage"> 智铺中心 </span>
							装修模块
						</div>

						<div>
							<el-table
							:data="tableData"
							v-loading="tableLoading"
							:header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
							:cell-style="{ 'text-align': 'left' }"
							style="width: 95%; margin: 0 auto"
							>
								<template slot="empty">
									<div>
										<img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
										<span style="margin-left: -140px">暂无定制模块~</span>
									</div>
								</template>
								<el-table-column prop="name" label="模块名称">
								</el-table-column>

								<el-table-column prop="id" label="模块ID"></el-table-column>

								<el-table-column prop="updateTime" label="最后修改时间"></el-table-column>

								<el-table-column label="操作">
									<template slot-scope="scope">
										<!-- <span v-if="scope.row.sendStatus == 0">发放成功</span> -->
										<span
											style="cursor: pointer;color: #7b61ff;"
											@click="toDetails"
											>详情</span>
									</template>
								</el-table-column>
						
							</el-table>
						</div>
					</div>

				</div>
		</div>
	</div>

	<div v-if="!isHome">
		<brandDetails  @returnBack="returnBackChange"></brandDetails>
	</div>
</div>
</template>

<script>
import topTitle from "../../components/top-title";
import brandDetails from "./brandDetails";
import { getConfigInfo } from "@/api/brandCustom/brandMemberCenter";
export default {
name: '' ,
components: {
	topTitle,
	brandDetails
},
props:{},
data() {
return {
	isHome:true,
	tabActive: "1",
	tableLoading: false,
	tableData: [],
}
},
computed: {},
created() {

},
mounted() {
	this.getList()
},
methods: {
	getList(){
		this.tableLoading = true,
		getConfigInfo().then((res) => {
			this.tableLoading = false;
			if (res.code == 1) {
				this.tableData = res.data;
			}else{
				this.$message.error(res.message);
			}
		});
	},
  handleClick(tab) {
		if (tab.name == "1") {
			this.getList()
		}
	},
	toPage(){
		window.open("https://jshopx.jd.com/pageManage/m?projectType=6");
	},
	toDetails(){
		this.isHome = false;
	},
	returnBackChange() {
		this.isHome = true;
	}
}
}
</script>
<style lang='scss' scoped>
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin: 20px 0;
  padding: 12px 0px 12px 20px;
  .card-connet {
    p {
      line-height: 26px;
      font-size: 14px;
      color: #333333;
    }
  }
}
.integralEden {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1110px;
  .content {
    min-height: 720px;
    background: rgba(255, 255, 255, 1);
    border-radius: 6px;
  }
}

</style>